// extracted by mini-css-extract-plugin
module.exports = {"loading":"loading-indicator_loading__mAMX1"};